import { type Codec, type Format } from './types';

const CODECS: Record<Format, Codec> = {
  webm: 'opus',
  mp4: 'mp4a',
};

export const getCodec = (format: Format): Codec => CODECS[format];
